<template>
    <hooper :wheelControl="false" :autoPlay="true" :playSpeed="5000" :rtl="rtl">
        <slide v-for="(item,index) in ads" :key="index">
            <div class="ads-slider-item">
                <video controls   height="100%" width="100%" v-if="item.video_url" :src="JSON.parse(item.video_url)[lang]"></video>
                <img v-else-if="item.image" :src="JSON.parse(item.image)[lang]" alt="">
                <a v-if="item.url && JSON.parse(item.url) && JSON.parse(item.url)[lang]" :href="JSON.parse(item.url)[lang]">
                    <span v-if="item.button_caption && JSON.parse(item.button_caption) && JSON.parse(item.button_caption)[lang]">{{JSON.parse(item.button_caption)[lang]}}</span>
                    <span v-else>{{word.more}}</span>
                </a>
            </div>
        </slide>
    </hooper>
</template>

<script>
    import {Hooper, Slide} from "hooper";
    import "hooper/dist/hooper.css";

    export default {
        props: {
            ads: {
                type: [Array, Object],
                required: true
            },
            lang: {
                type: String,
                required: true
            },
            dir: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                word: window.word,
                text: window.text,
                rtl: window.rtlVal
            }
        },
        components: {
            Hooper,
            Slide
        }
    };
</script>
<style>
    .hooper {
        height: calc(100vh - 90px);
    }

    .hooper .hooper-slide .hooper-img {
        width: 100%;
        height: 100%;
    }
</style>
